import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'inhabitant-changes',
    component: Children,

    children: [
      {
        path: '',
        name: 'inhabitant-changes',
        component: () => import('../pages/InhabitantChangesPage.vue')
      }
    ]
  }
];

export default routes;
